<div class="d-flex justify-content-end mb-2">
    <div
        class="clear-filters"
        (click)="clearAllFilters()"
        (keypress)="clearAllFilters()"
        tabindex="0"
    >
        Clear All Filters
    </div>
</div>
<div class="d-flex justify-content-between w-100 mb-1">
    <telxl-multiselect-dropdown
        class="me-1 w-25"
        colour="dropdown"
        placeholder="Agent"
        [size]="'sm'"
        [outline]="true"
        [menuItems]="agentMenuItems()"
        [selected]="agents()"
        [disabled]="hideAgentsMenu()"
        (selectedChange)="onAgentsChanged($event)"
    />
    <telxl-multiselect-dropdown
        class="me-1 w-25"
        colour="dropdown"
        placeholder="Channel"
        [size]="'sm'"
        [outline]="true"
        [menuItems]="channelMenuItems()"
        [selected]="channels()"
        (selectedChange)="onChannelsChanged($event)"
    />
    <telxl-multiselect-dropdown
        class="me-1 w-25"
        colour="dropdown"
        placeholder="Media"
        [size]="'sm'"
        [outline]="true"
        [menuItems]="mediaMenuItems()"
        [selected]="channelTypes()"
        (selectedChange)="onChannelTypesChanged($event)"
    />
    <telxl-dropdown
        class="w-25"
        colour="dropdown"
        placeholder="Direction"
        [size]="'sm'"
        [outline]="true"
        [menuItems]="directionMenuItems()"
        [selected]="direction()"
        (selectedChange)="onDirectionChanged($event)"
    />
</div>
<div class="d-flex justify-content-between w-100 mb-2">
    <telxl-datepicker
        class="me-1 w-50"
        [fromDate]="fromDate()"
        [toDate]="toDate()"
        [range]="true"
        [maxDate]="today()"
        [autoClose]="'outside'"
        (dateRangeSelected)="onDateRangeSelected($event)"
    />
    <telxl-dropdown
        class="me-1 w-20"
        colour="dropdown"
        placeholder="Sort"
        [size]="'sm'"
        [outline]="true"
        [menuItems]="sortMenuItems()"
        [selected]="sort()"
        (selectedChange)="onSortChanged($event)"
    />
    <telxl-multiselect-dropdown
        class="w-30"
        colour="dropdown"
        placeholder="Completion Code"
        [size]="'sm'"
        [outline]="true"
        [menuItems]="completionCodeMenuItems()"
        [selected]="completionCodes()"
        (selectedChange)="onCompletionCodesChanged($event)"
    />
</div>
<div
    #scrollContainer
    class="scroll-container mt-2"
    [style.height]="height()"
    [style.max-height]="height()"
>
    @for (activity of customerActivity().historicActivity; track activity.id) {
        <telxl-shared-activity-history-item
            data-testid="activity-history-component"
            [activity]="activity"
            variation="customer"
        />
    } @empty {
        @if (!isLoading()) {
            <div
                data-testid="no-data-component"
                class="d-flex flex-column align-items-center justify-content-center h-100"
            >
                <i class="fa-thin fa-face-zipper text-primary"></i>
                <div class="font-xxl mt-4">No data!</div>
                <div class="mt-4 mb-5">No customer activity found.</div>
            </div>
        } @else {
            <div class="h-100 w-100" data-testid="loading-component">
                <telxl-loading size="3rem" />
            </div>
        }
    }
</div>
